import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button } from "reactstrap"
import { IndexType } from "components/Extra"
import CampaignsTable from "pages/vendor/Campaigns/CampaignsTable"
import { FilterData } from "components/Extra"
import { CampaignsGrid } from "pages/vendor/Campaigns/CampaignsGrid"
import { AddNewCampaign } from "pages/vendor/Campaigns/Modals/AddNewCampaign"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import classNames from "classnames"

export enum CurrentTapType {
  all = "campaigns_all",
  active = "campaigns_active",
  inActive = "campaigns_inActive",
  ended = "campaigns_ended",
}

const tabs = [
  CurrentTapType.all,
  CurrentTapType.active,
  CurrentTapType.inActive,
  CurrentTapType.ended,
]

export interface Campaign {
  title: string
  id: string
  category: string
  startDate: string
  endDate: string
  periodTime: string
  price: string
  status: CurrentTapType.active | CurrentTapType.inActive | CurrentTapType.ended
}

const campaignsData: Campaign[] = [
  {
    title: "Campaign Title",
    id: "ID-145871",
    category: "Banner",
    startDate: "25 May, 2025",
    endDate: "12 Aug, 2025",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.active,
  },
  {
    title: "Campaign Title",
    id: "ID-145872",
    category: "Featured",
    startDate: "25 Aug, 2025",
    endDate: "12 Sep, 2025",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.active,
  },
  {
    title: "Campaign Title",
    id: "ID-145873",
    category: "Email Campaigns",
    startDate: "25 Aug, 2025",
    endDate: "12 Sep, 2025",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.inActive,
  },
  {
    title: "Campaign Title",
    id: "ID-145874",
    category: "Video Campaigns",
    startDate: "25 May, 2023",
    endDate: "12 Jun, 2023",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.ended,
  },
  {
    title: "Campaign Title",
    id: "ID-145875",
    category: "Mobile Campaigns",
    startDate: "25 May, 2023",
    endDate: "12 Jun, 2023",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.ended,
  },
  {
    title: "Campaign Title",
    id: "ID-145876",
    category: "Featured",
    startDate: "25 May, 2023",
    endDate: "12 Jun, 2023",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.ended,
  },
  {
    title: "Campaign Title",
    id: "ID-145877",
    category: "Banner",
    startDate: "25 May, 2023",
    endDate: "12 Jun, 2023",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.ended,
  },
]

export const Campaigns = () => {
  const { t } = useTranslation()

  const [currentTap, setCurrentTap] = useState<CurrentTapType>(CurrentTapType.all)
  const [activeTab, setActiveTab] = useState<IndexType>("list-ul")
  const [checkedCampaigns, setCheckedCampaigns] = useState<Campaign[]>([])
  const [campaigns, setCampaigns] = useState<Campaign[]>([])
  const [filteredCampaigns, setFilteredCampaigns] = useState<Campaign[]>([])
  const [showAddNewCampaign, setShowAddNewCampaign] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    setFilteredCampaigns(campaignsData)
    setCampaigns(campaignsData)
  }, [])

  const changeTabHandler = useCallback(
    (tab: CurrentTapType) => {
      setCurrentTap(tab)
      if (tab === CurrentTapType.all) {
        setFilteredCampaigns(campaigns)
      } else {
        setFilteredCampaigns(campaigns.filter(campaign => campaign.status === tab))
      }
    },
    [campaigns]
  )

  const isAllChecked = useMemo(() => {
    return campaigns.length > 0 && checkedCampaigns.length === campaigns.length
  }, [campaigns, checkedCampaigns])

  const togglecheckedCampaignHandler = useCallback((campaign: Campaign) => {
    setCheckedCampaigns(prev =>
      prev.includes(campaign)
        ? prev.filter(c => c !== campaign)
        : [...prev, campaign]
    )
  }, [])

  const toggleAllCampaigns = useCallback(() => {
    setCheckedCampaigns(isAllChecked ? [] : campaigns)
  }, [isAllChecked, campaigns])

  const toggleActiveCampaign = useCallback(
    (campaign: Campaign) => {
      setCampaigns(prev =>
        prev.map(c =>
          c.id === campaign.id
            ? {
                ...c,
                status:
                  c.status === CurrentTapType.active
                    ? CurrentTapType.inActive
                    : CurrentTapType.active,
              }
            : c
        )
      )
    },
    [campaigns]
  )

  const addNewCampaignHandler = useCallback(() => {
    setShowAddNewCampaign(true)
  }, [])
  const editCampaignHandler = useCallback((campaign: Campaign) => {}, [])
  const viewDetailsHandler = useCallback((campaign: Campaign) => {
    navigate(`/campaigns/${campaign.id}`)
  }, [])
  const reOrderCampaignHandler = useCallback(() => {}, [])
  const deleteCampaignHandler = useCallback((campaign: Campaign) => {}, [])

  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("campaigns_campaigns")}
        />
        <Button
          onClick={addNewCampaignHandler}
          color="success"
          className="bg-gradiant-blue text-capitalize"
        >
          {t("campaigns_addNewCampaign")}
        </Button>
      </div>
      <ul className="nav nav-pills mb-3 px-2">
        {tabs.map(tab => (
          <li
            className="nav-item"
            style={{ flex: 1, textAlign: "center" }}
            key={tab}
          >
            <Link
              to="#"
              className={classNames(
                { active: currentTap === tab },
                "nav-link"
              )}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => changeTabHandler(tab)}
            >
              {t(tab)}
            </Link>
          </li>
        ))}
      </ul>
      <FilterData
        data={campaigns}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        bearerFilteredData={setFilteredCampaigns}
      />

      {/* Modals */}
      <AddNewCampaign
        isOpen={showAddNewCampaign}
        toggle={() => setShowAddNewCampaign(false)}
      />

      {activeTab == "list-ul" ? (
        <CampaignsTable
          campaigns={filteredCampaigns}
          isAllChecked={isAllChecked}
          checkedCampaigns={checkedCampaigns}
          toggleAllCampaigns={toggleAllCampaigns}
          togglecheckedCampaignHandler={togglecheckedCampaignHandler}
          toggleActiveCampaign={toggleActiveCampaign}
          editCampaignHandler={editCampaignHandler}
          viewDetailsHandler={viewDetailsHandler}
          deleteCampaignHandler={deleteCampaignHandler}
        />
      ) : (
        <CampaignsGrid
          campaigns={filteredCampaigns}
          toggleActiveCampaign={toggleActiveCampaign}
          editCampaignHandler={editCampaignHandler}
          viewDetailsHandler={viewDetailsHandler}
          reOrderCampaignHandler={reOrderCampaignHandler}
          deleteCampaignHandler={deleteCampaignHandler}
        />
      )}
    </div>
  )
}
